export const GraphType = {
    NONE: 'none',
    CUSTOM: 'custom',
    RECT: 'rect',
    ElLIPSE: 'ellipse',
    TRIANGLE: 'triangle',
    ROUNDRECT: 'roundRect',
    MOON: 'moon',
    PENTAGON: 'pentagon',
    RTTRIANGLE: 'rtTriangle',
    RIGHTARROW: 'rightArrow',
    LEFTARROW: 'leftArrow',
    MATHMINUS: 'mathMinus',
    MATHPLUS: 'mathPlus',
    SNIP1: 'snip1Rect',
    FLOWCHARTALTERNATEPROCESS: 'flowChartAlternateProcess',
    FLOWCHARTPROCESS: 'flowChartProcess',
    IRREGULARSEAL1: 'irregularSeal1',
    IRREGULARSEAL2: 'irregularSeal2',
    WEDGERECTCALLOUT: 'wedgeRectCallout',
    WEDGEROUNDRECTCALLOUT: 'wedgeRoundRectCallout',
    CHEVRON: 'chevron',
    DIAMOND: 'diamond',
    UPARROW: 'upArrow',
    DOWNARROW: 'downArrow',
    HEXAGON: 'hexagon',
    PARALLELOGRAM: 'parallelogram',
    SNIP2SAMERECT: 'snip2SameRect',
    SNIP2DIAGRECT: 'snip2DiagRect',
    SNIPROUNDRECT: 'snipRoundRect',
    ROUND1RECT: 'round1Rect',
    ROUND2SAMERECT: 'round2SameRect',
    ROUND2DIAGRECT: 'round2DiagRect',
    Trapezoid: 'trapezoid',
    Octagon: 'octagon',
    Pie: 'pie',
    Chord: 'chord',
    Frame: 'frame',
    HalfFrame: 'halfFrame',
    DiagStripe: 'diagStripe',
    Plus: 'plus',
    Plaque: 'plaque',
    Can: 'can',
};

export const FillMode = {
    NONE: 99,      // 背景透明
    NORMAL: 100,   // 默认
    BRIGHT: 101,  // 亮
    BRIGHTER: 102, // 更亮
    DARK: 103,  // 暗
    DARKER: 104,  // 更暗
};
